<template>
  <default-layout>
    <section slot="content">
      <v-container fluid>
        <v-row justify="center" class="mt-10">
          <v-col cols="12" md="10" xs="12">
            <v-row justify="center">
              <v-col cols="12" lg="4" md="6" sm="8" xs="12">
                <v-card style="border: 0" outlined elevation="0">
                  <v-card-title class="justify-center">
                    <v-icon size="80" color="primary">local_shipping</v-icon>
                  </v-card-title>
                  <v-card-title class="justify-center">
                    <p class="text--primary text-center">
                      ¡Seguimiento de mi pedido!
                    </p>
                  </v-card-title>
                  <v-card-text>
                    <div class="text--primary text-center">
                      Para consultar el estado de su pedido por favor completar los siguientes campos.
                    </div>
                  </v-card-text>
                  <v-card-text>
                    <template>
                      <v-form
                        ref="form"
                        v-model="form"
                      >
                        <v-text-field
                          v-model="orderNumber"
                          filled
                          :rules="[rules.required]"
                          color="primary"
                          label="Número de pedido"
                          outlined
                          dense
                        ></v-text-field>
                        <v-text-field
                          v-model="email"
                          filled
                          :rules="[rules.email]"
                          color="primary"
                          label="Correo"
                          type="email"
                          outlined
                          dense
                        ></v-text-field>
                      </v-form>
                    </template>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      :disabled="!form"
                      @click="trackOrder()"
                      color="primary"
                      block
                      depressed
                    >
                      Continuar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <template>
          <div class="text-center ma-2">
            <v-snackbar
              v-model="snackbar"
              :color="color"
              top
            >
              {{ message }}
              <template v-slot:action="{ attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
                >
                  X
                </v-btn>
              </template>
            </v-snackbar>
          </div>
        </template>
      </v-container>
    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'

  export default {
    name: 'OrderTrackingLogin',
    components: {
      DefaultLayout
    },
    data () {
      return {
        orderNumber: '',
        email: '',
        form: false,
        rules: {
          email: v => /.+@.+\..+/.test(v) || 'Por favor ingresar un correo válido',
          length: len => v => (v || '').length >= len || `Invalid character length, required ${len}`,
          required: v => !!v || 'Por favor completar este campo',
        },

        color: 'green',
        message: '',
        snackbar: false
      }
    },
    methods: {
      errorLogin () {
        if (this.email &&
            this.orderNumber &&
            /.+@.+\..+/.test(this.email)) {
          return false;
        }

        return true;
      },
      trackOrder () {
        if (this.errorLogin()) {
          this.snackbar = true;
          this.text = '¡Ingresar datos por favor!';
          this.color = 'red';
          return;
        }

        const request = {
          email: this.email,
          order_number: this.orderNumber
        };

        axios.post(process.env.DINO.PATH.LOGIN_FIND_ORDER_DETAIL, request)
        .then(response => {
          this.color = response.data.success ? 'green' : 'red';
          this.message = response.data.message;
          this.snackbar = true;
          if (response.data.success) {
            localStorage.setItem('orderNumber', this.orderNumber);
            this.$router.push({ name: 'OrderTrackingDetail' }).catch(err => {});
          } else {
            localStorage.removeItem('orderNumber');
          }
        })
        .catch(err => {
          localStorage.removeItem('orderNumber');
        });
      }
    },
    mounted: function () {
      localStorage.removeItem('orderNumber');
    }
  }
</script>
<style scoped>

.v-text-field >>> input {
  font-size: 0.9em;
}

.v-text-field >>> label {
  font-size: 0.9em;
}

</style>



// WEBPACK FOOTER //
// src/views/OrderTrackingLogin.vue